<template>
    <v-fab-transition>
        <div v-show="active">
            <v-expand-transition>
                <v-card
                        class="pulse_me"
                        width="506"
                        v-if="stage===1"
                        height="341"
                        style="margin-top:200px;margin-left:40px;"
                        :img="require('../assets/cd/flak.png')"
                        flat
                >



                </v-card>


            </v-expand-transition>
            <v-fab-transition>
                <v-img v-show="stage===1" contain height="300" width="300"  style="position: absolute; left: 250px; z-index: 2; top: -20px;" :src="require('../assets/cd/banner_7.png')">

                </v-img>
            </v-fab-transition>
            <v-fade-transition>
            <div v-show="stage===1"  class="text-center" style="max-width:200px;max-height: 320px !important; position: absolute; top: 150px; border-left: inset; z-index: 0; left: 550px;border: 0px !important;overflow-y:hidden !important;">
                <v-chip
                        v-for="(user,index) in voters"
                        :key=index
                        color="#ff3b77"
                        dark

                        class="my-1"
                >
                    <b>{{user}}</b>
                </v-chip>

            </div>
            </v-fade-transition>
            <v-chip


                    dark
                    style="position: absolute;left:610px;margin-top:-180px !important;"
                    class="ma-1"
                    v-if="voters.length>8 && stage===1"
            >
                +<b>{{voters.length-8 }} </b> <span class="ml-1">andra</span>
            </v-chip>
            <v-fade-transition>
            <v-progress-circular
                    :rotate="270"
                    :size="150"
                    :width="10"
                    :value="(timeleft/120000)*100"
                    color="#ff3b77"
                    style="position:absolute;left:40px;top:40px;"
                    v-show="stage===1"
            >

            </v-progress-circular>
            </v-fade-transition>
            <v-fade-transition>
            <v-img v-show="stage===1" style="left:40px;top:40px;position:absolute;z-index:-1;" width="150" height="150" :src="require('../assets/cd/cd_color.png')">

            </v-img>
            </v-fade-transition>
            <v-fade-transition>
            <v-img v-show="stage===3" style="left:160px;top:80px;position:absolute;z-index:-1;" width="150" height="150" :src="require('../assets/cd/arrow_down.png')">

            </v-img>
            </v-fade-transition>
            <v-fade-transition>
            <v-img v-show="stage===5" style="left:10px;top:-100px;position:absolute;z-index:-1;" width="450" height="450" :src="require('../assets/cd/gz.png')">

            </v-img>
            </v-fade-transition>
            <v-carousel v-if="stage>2"  v-model="winner_hint" style="height:500px;width:500px;position:absolute;top:0;left:0;"
                        :show-arrows=false
                        :hide-delimiters=true
                        :hide-delimiter-background=true

            >
                <v-carousel-item
                        v-for="(user, i) in voters"
                        :key="i"
                >
                    <v-row style="height:100%;width:100%;" align="center" justify="center">
                        <v-col cols="6" style="text-align: center;">
                            <v-chip
                                    color="#ff3b77"
                                    dark

                                    class="my-1"
                            >
                                <b>{{user}}</b>
                            </v-chip>
                        </v-col>
                    </v-row>


                </v-carousel-item>
            </v-carousel>
        </div>
    </v-fab-transition>


</template>

<script>
    export default {
        name: "SponsFlak",
        data() {
            return {
                active:false,
                stage:0,
                timeleft:120000,
                votes:[],
                voters:[],
                winners:[],
                scroll_list:[],
                winner_hint:0


            }
        },
        mounted:function(){
            let u=this.$route.query.u;
            this.$socket.emit('spons_listen_ga',u);

            //this.go();


        },

        computed: {

        },

        sockets: {


            show_ga:function(){
                this.resetAll();
                this.go();

            },
            giveaway:function(user){
                if(!this.voters.includes(user)){
                    this.voters.unshift(user)
                }



            },
            connected:function(){
            }
        },
        methods:{



            resetAll:function(){
                this.stage=0;
                this.voters=[];
                this.active=false;
                this.winner_hint=0;
            },

            go:function(){
                let self=this;

                setTimeout(function(){
                    self.active=true;
                },500);
                setTimeout(function(){
                    self.stage=1;
                },1000);

                setInterval(function(){
                    self.timeleft-=300;

                },300);

                setTimeout(function(){
                    self.stage=2;

                },120000);

                setTimeout(function(){
                    let first_phase=Math.round(1+Math.random());
                    let second_phase=Math.round(1+Math.random());
                    self.stage=3;
                    let clear_me=setInterval(function(){
                        self.winner_hint+=1;
                    },100);
                    setTimeout(function(){
                        let clear_me2=setInterval(function(){
                            self.winner_hint+=1;
                        },300);
                        clearInterval(clear_me);

                        setTimeout(function(){

                            clearInterval(clear_me2);
                            setTimeout(function(){
                                self.stage=4
                            },1000);
                            setTimeout(function(){
                                self.stage=5
                            },1500);
                            self.$socket.emit('bye_spons_ga',[self.voters.length,self.voters[self.winner_hint]]);
                            setTimeout(function(){
                                self.resetAll();
                            },8000);



                        },5000*second_phase)



                    },10000*first_phase)
                },120500);



            }


        }
    }
</script>

<style>
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
    @keyframes MOVE-BG {

        from {
            -webkit-transform: translateX(-200px);
            -moz-transform: translateX(-200px);
            -ms-transform: translateX(-200px);
            -o-transform: translateX(-200px);
            transform: translateX(-200px);

        }
        to {

            -webkit-transform: translateX(-350px);
            -moz-transform: translateX(-350px);
            -ms-transform: translateX(-350px);
            -o-transform: translateX(-350px);
            transform: translateX(-350px);

        }
    }
    .move_bg{
        animation-name: MOVE-BG;
        animation-duration: 30s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: 1;
        -webkit-animation-fill-mode: forwards;
    }

    .hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 2s, opacity 2s linear;
    }
    .visible {
        visibility: visible;
        opacity: 1;
    }

    .shake_me{
        animation: shake 0.3s;
    }

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }
    @keyframes pulse {
        0% {
            transform: scale(1, 1);
        }

        50% {
            transform: scale(1.05, 1.05);
        }

        100% {
            transform: scale(1, 1);
        }
    }

    .pulse_me {
        animation: pulse 3s ease-in-out infinite;
    }
</style>
